<template>
  <v-card :loading="loading">
    <v-list-item v-for="item in equipment" :key="item.id+'additional'">
      <v-list-item-content>
        <p class="headline mb-0">{{item.description}}</p>
        <p class="title mb-0 ml-5" v-if="item.notes" style="white-space: pre;">{{item.notes}}</p>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  props: {
    equipment: Array,
    loading: Boolean
  }
}
</script>